
<template>
    <v-dialog
            v-if="getModalType === 'info' || getModalType === 'map'"
            class="modal"
            v-model="dialog"
            :persistent="true"
            @keydown.esc="closeHandler">
        <div class="modal__inner">
            <div class="modal__close" @click.prevent="closeHandler"><svg-icon name="close"></svg-icon></div>
            <div class="modal__body">
                <div class="modal__body-title font-semi">
                    {{$t('modal.more')}}
                </div>
                <div class="modal__item"
                     v-for="(value, key) in list"
                     :key="key"
                >
                    <div class="modal__item-in" v-if="key === 'gender'">
                        <div class="modal__title">
                            {{ $t(`table.${key}`) }}:
                        </div>
                        <div class="modal__sub">
                            <svg-icon :name="value ? 'male' : 'female'"></svg-icon>
                        </div>
                    </div>
                    <div class="modal__item-in" v-else-if="key.includes('date')">
                        <div class="modal__title">
                            {{ $t(`table.${key}`) }}:
                        </div>
                        <div class="modal__sub">
                            {{formatDate(value)}}
                        </div>
                    </div>
                    <div class="modal__item-in" v-else>
                        <div class="modal__title" >
                            {{ $t(`table.${key}`) }}:
                        </div>
                        <div class="modal__sub">{{value}}</div>
                    </div>


                </div>
                <div class="modal__map" v-if="getModalType === 'map'">
                    <button class="btn btn-m btn-gradient btn-h40 modal__map-btn" @click="goToMap">
                        <span>Studio page</span>
                    </button>
                </div>
            </div>
            <div class="modal__footer" v-if="getModalData.tooltip">
                <!--@click="extendHandler(getModalData.tooltip.expired_id)"-->
                <!--@click="deleteHandler(getModalData.tooltip.id)"-->

                <div class="modal__action" v-if="!getModalData.tooltip.unverified">
                    <button class="btn btn-extend"
                            @click="showModal('Extend')"
                            v-if="!buttonExtendIsDisabled">
                        {{$t('modal.action.Extend.title')}}
                    </button>

                    <button class="btn btn-delete"
                            @click="showModal('Delete')"
                    >
                        {{$t('modal.action.Delete.title')}}
                    </button>
                </div>
                <div class="modal__action" v-else>
                    <button class="btn btn-extend"
                            @click="showModal('Approve')">
                        {{$t('modal.action.Approve.title')}}
                    </button>

                    <button class="btn btn-delete"
                            @click="showModal('Decline')"
                    >
                        {{$t('modal.action.Decline.title')}}
                    </button>
                </div>


            </div>
        </div>
    </v-dialog>
</template>

<script>
    import { mapGetters } from 'vuex';
    import actions from '@/mixins/actions'
    import {isUndefined} from '@/helpers/helpers'
    import formatDateMixin from "@/mixins/formatDateMixin";
    export default {
        mixins: [actions, formatDateMixin],
        methods: {
            goToMap() {
               this.$store.commit('CLOSE_MODAL');
               this.$router.push({ name: 'members-studio-page', params: { slug: this.tableData.data[this.getCurrentItemIndex].slug, item: this.tableData.data[this.getCurrentItemIndex] }});
            },
            showModal(type) {
                this.$store.dispatch('SHOW_MODAL', {state: true, type: type, data: this.getModalData.tooltip })
            }

        },
        computed: {
            ...mapGetters([
                'getCurrentItemIndex',
            ]),
            tableData() {
              return this.$store.getters.tableData
            },
            buttonExtendIsDisabled() {
                let {is_expired, days_remaining} = this.getModalData.tooltip;
                if(!isUndefined(is_expired) && !isUndefined(days_remaining)) {
                    if(is_expired || !days_remaining) return false
                }
                return true
            },
            list() {
                let data = {...this.getModalData}
                if ('tooltip' in data) {
                    delete data.tooltip
                }
                return data
            }
        }
    }
</script>

<style lang="sass" scoped="">
    .modal
        &__inner
            background-color: $color--white
            position: relative
        &__close
            position: absolute
            top: 10px
            right: 10px
            cursor: pointer
            padding: 10px
            .icon-close
                width: 12px
                height: 12px
                +tr(fill .3s ease)
                fill: rgba($color--dark, 0.3)
                &:hover
                    fill: rgba($color--dark, 0.8)
        &__item
            font-size: 14px
            line-height: 16px
            margin-top: 15px
            &-in
                display: flex
                align-items: center
        &__body
            padding: 24px 16px 16px
            &-title
                letter-spacing: 0.005em
                font-size: 16px
                color: $color--dark
        &__map
            margin-top: 24px
            &-btn
                width: 100%
        &__title
            color: rgba($color--dark, 0.5)
            /*text-transform: capitalize*/
            +semi
        &__sub
            +reg
            margin-left: 4px
            text-overflow: ellipsis
            overflow: hidden
            flex: 1
            .svg-icon
                width: 16px
                height: 16px
        &__footer
            display: flex
            justify-content: center
            align-items: center
            border-top: 1px solid rgba(1, 37, 78, 0.1)
            height: 60px
            .btn
                height: 100%
                padding: 20px
                flex: 1
                text-align: center
                &:last-of-type
                    border-left: 1px solid rgba(1, 37, 78, 0.1)
        &__action
            width: 100%
            display: flex
            justify-content: center
    .dialog
        width: 100%
    .v-dialog__content
        align-items: flex-end
</style>
